
import React from "react";
import { 
  isPuttingTest,
  isChippingTest,
  isWedgingTest,
  isBunkerTest,
  isIronTest,
  isFairwayWoodTest,
  isDriverTest
} from "../../level3/scoring/utils";

interface TestTypeDetectorProps {
  testId: string | null;
  propIsChippingTest?: boolean;
  propIsWedgingTest?: boolean;
  propIsBunkerTest?: boolean;
  children: (types: TestTypes) => React.ReactNode;
}

export interface TestTypes {
  isPutting: boolean;
  isChipping: boolean;
  isWedging: boolean;
  isBunker: boolean;
  isIron: boolean;
  isFairwayWood: boolean;
  isDriver: boolean;
}

const TestTypeDetector: React.FC<TestTypeDetectorProps> = ({
  testId,
  propIsChippingTest,
  propIsWedgingTest,
  propIsBunkerTest,
  children
}) => {
  // Déterminer si nous sommes dans le niveau 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  // Détecter le type de test
  const isPutting = isPuttingTest(testId);
  const isChipping = propIsChippingTest || isChippingTest(testId);
  const isWedging = propIsWedgingTest || isWedgingTest(testId);
  const isBunker = propIsBunkerTest || isBunkerTest(testId);
  
  // Pour les tests spécifiques au niveau 2, vérifier les ID spécifiques
  let isIron = isIronTest(testId);
  let isFairwayWood = isFairwayWoodTest(testId);
  let isDriver = isDriverTest(testId);
  
  if (isLevel2) {
    if (testId?.includes('iron-')) isIron = true;
    if (testId?.includes('fairwayWood-')) isFairwayWood = true;
    if (testId?.includes('driver-')) isDriver = true;
  }

  const testTypes: TestTypes = {
    isPutting,
    isChipping,
    isWedging,
    isBunker,
    isIron,
    isFairwayWood,
    isDriver
  };

  return <>{children(testTypes)}</>;
};

export default TestTypeDetector;
